require('./bootstrap');

import { Tooltip, Toast, Popover, Dropdown } from 'bootstrap'
import { createApp } from 'vue'
import HighchartsVue from 'highcharts-vue'

import dash from './Dash/Dash.vue'
import listEvent from './Dash/List.vue'
import monthlyTotals from './Dash/MonthlyTotals.vue'
import yearlyTotals from './Dash/YearlyTotals.vue'
import monthlyAverages from './Dash/MonthlyAverages.vue'

import createEvent from './Event/Create.vue'
import editEvent from './Event/Edit.vue'

import bingmap from './Map/BingMap.vue'

const axios = require('axios')

// Setup the main app
const app = createApp({
    components: {
      'dash': dash,
      'list-event': listEvent,
      'monthly-totals': monthlyTotals,
      'yearly-totals': yearlyTotals,
      'monthly-averages': monthlyAverages,
      'create-event': createEvent,
      'edit-event': editEvent,
      'bingmap': bingmap,
    }
})
app.use(HighchartsVue)
app.mount('#app')
